<ng-template let-extraClass="extraClass" #topNav>
  @if (!isRightSideContent && !windowService.isDesktopRes) {
    <tidy-top-nav
      [title]="'Past Job'"
      [class]="extraClass"
      [canGoBack]="true"
      [customBack]="backPage" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    @if (!isRightSideContent && windowService.isDesktopRes) {
      <tidy-desktop-header [isLoading]="!loaded">
        <div class="wrappable-container">
          <tidy-image
            [src]="'assets/svg/arrow-back-black.svg'"
            (action)="goBack()"
            class="desktop-back-icon" />
          <tidy-text [title]="'Past Job'" />
          <tidy-small-button
            [text]="'Copy Public Link'"
            [image]="'assets/svg/link-white.svg'"
            (click)="copyPublicLink()" />
          <tidy-small-button
            [text]="'Print PDF'"
            [image]="'assets/svg/printer-white.svg'"
            (click)="printPdf()" />
        </div>
      </tidy-desktop-header>
    }

    @if (errorMessage) {
      <tidy-error-message [text]="errorMessage" />
    }

    @if (loaded) {
      <ion-row>
        <ion-col
          [sizeLg]="!isRightSideContent && windowService.isDesktopRes ? 8 : 12"
          [sizeSm]="!isRightSideContent && windowService.isDesktopRes ? 6 : 12">
          @if (isRightSideContent) {
            <tidy-row [align]="'center'" style="margin-bottom: 1rem;">
              <tidy-text
                [body]="'Print PDF'"
                class="link"
                (action)="printPdf()" />
            </tidy-row>
          }
          @if (job?.job?.status !== 'completed' && job?.job?.status !== 'incomplete' && job?.job?.state !== 'completed') {
            <tidy-row [align]="'center'">
              <tidy-text [body]="'Did they finish the job?'" />
              <tidy-text
                [body]="'Mark Complete'"
                class="link"
                (action)="goToMarkJobComplete()" />
            </tidy-row>
          }
          <tidy-card>
            <tidy-row [alignLastItemRight]="true">
              <tidy-image
                [src]="job?.booking?.bookable_service?.icon_url"
                class="header-size" />
              <tidy-text
                [header]="(job?.job?.service_type_details?.name || job?.booking?.bookable_service?.name) | titlecase" />
              <tidy-text
                [body]="job?.job?.date | parseDateTime: 'EEE MMM d'" />
            </tidy-row>
            <tidy-row [alignLastItemRight]="true" class="extra-bottom-padding">
              <tidy-text
                  [helper]="displayAddress"
                  [translate]="false" />
                <tidy-text
                  [helper]="job?.job?.start_time | parseDateTime: 'h:mma'" />
            </tidy-row>
            @for (pro of job?.homekeepers; track pro) {
              <tidy-row [alignLastItemRight]="true">
                <tidy-initials-icon
                  style="margin-right: 5px"
                  [fullName]="pro?.name" />
                <tidy-text
                  [body]="pro.name"
                  [translate]="false" />
                @if (windowService.isDesktopRes) {
                  <tidy-text [body]="pro?.phone | telephone" />
                }
                @if (!windowService.isDesktopRes) {
                  <tidy-text
                    [body]="pro?.phone | telephone"
                    (action)="contactPro(pro?.phone)"
                    class="link" />
                }
              </tidy-row>
            }
            <tidy-row class="extra-top-padding vertical-align-center">
              <tidy-image
                [src]="'assets/img/clock-black.svg'"
                class="header-size" />
              <tidy-text [body]="'Job Duration'" />
              @if (!proReportedDuration && !fromStartDuration) {
                <tidy-text [body]="': N/A'" />
              }
            </tidy-row>
            @if (proReportedDuration) {
              <tidy-row>
                <tidy-text [body]="'Reported by Pro:'" /><span>&nbsp;</span>
                <tidy-text [body]="proReportedDuration" />
              </tidy-row>
            }
            @if (fromStartDuration) {
              <tidy-row>
                <tidy-text [body]="'Using Realtime Updates:'" />
                <tidy-text [body]="fromStartDuration" />
              </tidy-row>
            }
            @for (event of jobEvents; track event) {
              @if (event?.event?.name === 'samantha_service.booking.created') {
                <tidy-row>
                  <tidy-text
                    [body]="event?.text + (' on ' | translate) + (event?.happened_at | parseDateTime:'MMM d':'local') + (' at ' | translate) + (event?.happened_at | parseDateTime:'h:mma':'local')" />
                </tidy-row>
              }
            }
          </tidy-card>

          @if (!job?.homekeepers?.length) {
            <tidy-row [align]="'center'">
              <tidy-text [body]="'This job was cancelled. Talk to your pro for more info.'" />
            </tidy-row>
          }

          @if (job?.homekeepers?.length) {
            @if (isRightSideContent || !windowService.isDesktopRes) {
              <tidy-card style="padding: 0px">
                <div [attr.id]="'map' + jobId" #map style="width: 100%; height: 300px; border-radius: 6px;"></div>
              </tidy-card>
            }

            @if (invoiceIsLoaded) {
              <tidy-card>
                <tidy-card-button (action)="goToInvoicePage()" class="arrow-to-top" [hideArrow]="!invoice">
                  <tidy-row
                    [alignLastItemRight]="(invoice && !invoice?.full_paid) || !invoice"
                    [ngClass]="((invoice && !invoice?.full_paid) || !invoice) ? '' : 'vertical-align-center'">
                    <tidy-image
                      [src]="'assets/img/dollar.svg'"
                      class="title-size" />
                    <tidy-text [header]="invoice ? 'Balance' : 'Quoted Price'" />
                    @if (invoice && !invoice?.full_paid) {
                      <tidy-text
                        [body]="invoice?.amount_due*-1 | tcurrency"
                        style="margin-right:5px" />
                    }
                    @if (!invoice) {
                      <tidy-text
                        [body]="job?.booking?.bookable_service?.price | tcurrency"
                        style="margin-right:5px" />
                    }
                  </tidy-row>
                  @if (!invoice) {
                    <tidy-row>
                      <tidy-text
                        [body]="pro?.homekeeper?.first_name"
                        [translate]="false" /><span>&nbsp;</span>
                      <tidy-text [body]="'has not sent you a bill or marked this job as paid. The job was quoted to cost'" /><span>&nbsp;</span>
                      <tidy-text [body]="(job?.booking?.bookable_service?.price | tcurrency) + '.'" /><span>&nbsp;</span>
                      <tidy-text [body]="'Ask them to send you a bill if want to pay for this job.'" />
                    </tidy-row>
                  }
                  @if (!invoice?.full_paid && invoice) {
                    <tidy-row>
                      <tidy-text
                        [body]="pro?.homekeeper?.first_name"
                        [translate]="false" /><span>&nbsp;</span>
                      <tidy-text [body]="'sent you a'" /><span>&nbsp;</span>
                      <tidy-text [body]="invoice?.amount_due | tcurrency" /><span>&nbsp;</span>
                      <tidy-text [body]="'bill for this job'" />
                    </tidy-row>
                  }
                  @if (invoice?.full_paid) {
                    <tidy-row>
                      <tidy-text [body]="'You paid a'" /><span>&nbsp;</span>
                      <tidy-text [body]="(invoice?.amount + totalFees) | tcurrency" /><span>&nbsp;</span>
                      <tidy-text [body]="'bill for this bill.'" />
                    </tidy-row>
                  }
                </tidy-card-button>
              </tidy-card>
            }

            <tidy-card>
              <tidy-row class="vertical-align-center">
                <tidy-image
                  [src]="'assets/img/task-list.svg'"
                  class="header-size" />
                <tidy-text [header]="'Tasks'" />
              </tidy-row>
              <tidy-row class="vertical-align-middle">
                @if (tasksService.tasksLoaded && tasksService.linkedTasks.length === 0) {
                  <tidy-text [body]="'None linked'" />
                }
                @if (tasksService.tasksLoaded && tasksService.linkedTasks.length > 0) {
                  <ng-container class="vertical-align-middle">
                    @for (task of tasksService.linkedTasks; track task; let last = $last) {
                      <tidy-text
                        [body]="task.title"
                        (action)="tasksService.goToTask(task.id)"
                        class="link" />
                      @if (!last) {
                        <span>, &nbsp;</span>
                      }
                    }
                  </ng-container>
                }
                @if (!tasksService.tasksLoaded) {
                  <ion-skeleton-text
                    animated
                    style="margin-top: 5px; width: 80px; height: 13px" />
                }
                @if (showTasksDropdown) {
                  <tidy-task-dropdown
                    [priorPage]="'past-private-job'"
                    [priorPageParams]="isRightSidePanelAlreadyOpen ? {jobId: jobId} : null"
                    [bookingId]="job?.booking?.id"
                    [addressId]="job?.address?.id"
                    [jobId]="job?.job?.id" />
                }
              </tidy-row>
            </tidy-card>

            @if (isRightSideContent || !windowService.isDesktopRes) {
              <tidy-card>
                <tidy-card-button (action)="goToShareJobPage()">
                  <tidy-row class="vertical-align-center">
                    <tidy-image
                      [src]="'assets/img/paper-plane.svg'"
                      class="header-size" />
                    <tidy-text [header]="'Share Job Link'" />
                  </tidy-row>
                </tidy-card-button>
              </tidy-card>
            }

            @if (isRightSideContent || !windowService.isDesktopRes) {
              @for (item of activity; track item) {
                <tidy-card>
                  <tidy-row class="extra-bottom-padding" [alignLastItemRight]="true">
                    <div>
                      <tidy-initials-icon
                        [fullName]="item?.pro?.first_name + ' ' + (item?.pro?.last_name ? item?.pro?.last_name : '')"
                        style="margin-right: 5px;" />
                      <tidy-text
                        [header]="item?.pro?.text ? item?.pro?.text : (item?.pro?.first_name + ' ' + (item?.pro?.last_name ? item?.pro?.last_name : ''))"
                        [translate]="false" />
                    </div>
                    <div style="position: relative; margin-left: 5px">
                      @if (item?.pro?.first_name) {
                        <tidy-image
                          [src]="'assets/img/messages.svg'"
                          class="title-size white-icon"
                          (action)="goToMessageThreadPage(item?.pro)" />
                      }
                      @if (item?.numberOfUnreadMessages > 0) {
                        <div style="position: absolute; top: -8px; right: -8px; background: #CB393C; color: white; border-radius: 50%; min-width: 18px; height: 18px; display: flex; align-items: center; justify-content: center; font-size: 12px; padding: 0 4px; font-family: Inter, Arial, sans-serif;">
                          {{item?.numberOfUnreadMessages}}
                        </div>
                      }
                    </div>
                  </tidy-row>
                  @for (update of item?.updates; track update) {
                    <tidy-row>
                      <message [message]="update" />
                    </tidy-row>
                  }
                </tidy-card>
              }
            }

            <tidy-row [align]="'center'">
              <tidy-text
                [body]="'Rate This Job'"
                class="link"
                (action)="goToProHomepage()" />
            </tidy-row>

            @if (rooms?.length > 0) {
              <tidy-row class="extra-bottom-padding">
                <tidy-text [title]="'Checklist'" />
              </tidy-row>

              @if (bookingNote?.length || bookingFormAnswers?.length) {
                <tidy-card>
                  <tidy-card-button [hideArrow]="true">
                    <tidy-row class="vertical-align-center">
                      <tidy-image
                        [src]="'assets/img/information.svg'"
                        class="title-size" />
                      <tidy-text [header]="'Job Note'" />
                    </tidy-row>
                    @for (note of bookingNote; track note) {
                      <tidy-row>
                        @if (note?.type == 'text') {
                          <tidy-text [body]="note?.text" />
                        }
                        @if (note?.type == 'image') {
                          <tidy-image [src]="note?.media_url" />
                        }
                        @if (note?.type == 'video') {
                          <tidy-image [src]="note?.media_url" />
                        }
                      </tidy-row>
                    }
                    @for (answer of bookingFormAnswers; track answer) {
                      @if (answer?.template_input?.type == 'text' || answer?.template_input?.type == 'text_area') {
                        <tidy-row>
                          <tidy-text [body]="answer?.template_input?.label + ': ' + answer?.data?.value" />
                        </tidy-row>
                        @if (answer?.template_input?.image_url) {
                          <tidy-photo-note [src]="answer?.template_input?.image_url" />
                        }
                      }
                      @if (answer?.template_input?.type == 'select') {
                        <tidy-row>
                          <tidy-text [body]="answer?.template_input?.label + ': ' + me.getBookingFormSelectValue(answer?.data?.value)" />
                        </tidy-row>
                        @if (answer?.template_input?.image_url) {
                          <tidy-photo-note [src]="answer?.template_input?.image_url" />
                        }
                      }
                      @if (answer?.template_input?.type == 'multiselect') {
                        <tidy-row>
                          <tidy-text [body]="answer?.template_input?.label + ': ' + me.getBookingFormMultiselectValue(answer?.data?.value)" />
                        </tidy-row>
                        @if (answer?.template_input?.image_url) {
                          <tidy-photo-note [src]="answer?.template_input?.image_url" />
                        }
                      }
                      @if (answer?.template_input?.type == 'file' && answer?.template_input?.data?.type == 'image') {
                        <tidy-row>
                          <tidy-text [body]="answer?.template_input?.label" />
                        </tidy-row>
                        <tidy-carrousel
                          class="photo-notes-carrousel only-padding-bottom"
                          [scaleImages]="true">
                          <tidy-photo-note
                            *tidyCarrousel
                            [src]="answer?.data?.value" />
                        </tidy-carrousel>
                      }
                      @if (answer?.template_input?.type == 'files' && answer?.template_input?.data?.type == 'images') {
                        <tidy-row>
                          <tidy-text [body]="answer?.template_input?.label" />
                        </tidy-row>
                        <tidy-carrousel
                          class="photo-notes-carrousel only-padding-bottom"
                          [scaleImages]="true">
                          @for (imageUrl of answer?.data?.value; track imageUrl) {
                            <tidy-photo-note
                              *tidyCarrousel
                              [src]="imageUrl" />
                          }
                        </tidy-carrousel>
                      }
                    }
                  </tidy-card-button>
                </tidy-card>
              }

              <tidy-card>
                <div style="display: flex; align-items: center; justify-content: space-between;">
                  <div style="display: flex; align-items: center;">
                    <tidy-image
                      [src]="'assets/img/camera.svg'"
                      class="header-size" />
                    <tidy-text [header]="'Before Photos / Videos'" />
                  </div>
                  @if (isFullWidth) {
                    <div style="display: flex; align-items: center;">
                      <tidy-file-upload
                        [accept]="'image/*'"
                        [showPreview]="false"
                        [label]="isNativeMobile ? 'Upload Photo' : 'Add Photo'"
                        (addedImagesChange)="uploadPhoto($event, 'before_job')"
                        [showTextLink]="true"
                        style="margin-right: 10px" />
                      <tidy-file-upload
                        [accept]="'video/mp4'"
                        [showPreview]="false"
                        [label]="isNativeMobile ? 'Upload Video' : 'Add Video'"
                        (addedImagesChange)="uploadVideo($event, 'before_job')"
                        [showTextLink]="true" />
                    </div>
                  }
                </div>
                @if (!isFullWidth) {
                  <div style="margin-top: 10px; display: flex; align-items: center; align-items: center;">
                    @if (isNativeMobile) {
                      <tidy-text
                        [actionBody]="'Take Photo'"
                        (action)="takePhoto('before_job')"
                        class="link"
                        style="margin-right: 10px" />
                    }
                    <tidy-file-upload
                      [accept]="'image/*'"
                      [showPreview]="false"
                      [label]="isNativeMobile ? 'Upload Photo' : 'Add Photo'"
                      (addedImagesChange)="uploadPhoto($event, 'before_job')"
                      [showTextLink]="true"
                      style="margin-right: 10px" />
                    @if (isNativeMobile) {
                      <tidy-text
                        [actionBody]="'Take Video'"
                        (action)="takeVideo('before_job')"
                        class="link"
                        style="margin-right: 10px" />
                    }
                    <tidy-file-upload
                      [accept]="'video/mp4'"
                      [showPreview]="false"
                      [label]="isNativeMobile ? 'Upload Video' : 'Add Video'"
                      (addedImagesChange)="uploadVideo($event, 'before_job')"
                      [showTextLink]="true" />
                  </div>
                }
                @if (beforePhotos?.length == 0) {
                  <tidy-row class="extra-top-padding">
                    <tidy-text [helper]="'None Added'" />
                  </tidy-row>
                }
                <ion-row>
                  @for (item of beforePhotos; track item; let i = $index) {
                    <ion-col [size]="isFullWidth ? 6 : 12">
                      @if (item.mediaType === 'video') {
                        <tidy-row>
                          <tidy-video
                            class="before-after-video"
                            [src]="item?.url"
                            style="width: 100%; height: auto; max-width: 100%;" />
                        </tidy-row>
                      }
                      @if (item.mediaType === 'photo') {
                        @if (item?.url) {
                          <tidy-photo-note
                            class="full-width no-margin photo-note-job"
                            [src]="item?.url"
                            style="width: 100%; height: auto; max-width: 100%;" />
                        }
                      }
                      @if (item?.metadata || item?.uploadedBy) {
                        <div class="timestamp-caption">
                          <tidy-row [alignLastItemRight]="true">
                            <tidy-text
                              [smallBody]="('Uploaded by: ' | translate) + (item?.uploadedBy ? (item?.uploadedBy | translate) : ('you' | translate))"
                              class="white" />
                            <div>
                              <tidy-image
                                [src]="'assets/img/trash-outline-white.svg'"
                                (action)="removePhoto(item, i, 'before_job')"
                                class="body-size"
                                style="cursor: pointer" />
                            </div>
                          </tidy-row>
                          @if (item?.metadata?.location) {
                            <tidy-row>
                              <tidy-text
                                [smallBody]="'Location:'"
                                class="white" /><span>&nbsp;</span>
                              <tidy-text
                                [smallBody]="item?.metadata?.location"
                                class="white" />
                            </tidy-row>
                          }
                          @if (item?.metadata?.displayDate) {
                            <tidy-row>
                              <tidy-text
                                [smallBody]="'Timestamp:'"
                                class="white" /><span>&nbsp;</span>
                              <tidy-text
                                [smallBody]="(item?.metadata?.displayDate | parseDateTime: 'ddd MMM d') + ' ' + (item?.metadata?.displayDate | parseDateTime: 'h:mma')"
                                class="white" />
                            </tidy-row>
                          }
                        </div>
                      }
                    </ion-col>
                  }
                </ion-row>
              </tidy-card>

              <job-checklist-display
                [rooms]="rooms"
                [jobId]="jobId"
                [toDosProvider]="toDosProvider" />
            }

            <!-- Restocking results for this job (card gCUZuCjf). -->
            @if (restockTasks?.length > 0) {
              <tidy-row class="vertical-align-center">
                <tidy-image
                  [src]="'assets/svg/cube-outline.svg'"
                  class="header-size" />
                <tidy-text [header]="'Restocking'" />
              </tidy-row>
              <restock-tasks-display [tasks]="restockTasks" />
            }

            <tidy-card>
              <div style="display: flex; align-items: center; justify-content: space-between;">
                <div style="display: flex; align-items: center;">
                  <tidy-image
                    [src]="'assets/img/camera.svg'"
                    class="header-size" />
                  <tidy-text [header]="'After Photos / Videos'" />
                </div>
                @if (isFullWidth) {
                  <div style="display: flex; align-items: center;">
                    <tidy-file-upload
                      [accept]="'image/*'"
                      [showPreview]="false"
                      [label]="isNativeMobile ? 'Upload Photo' : 'Add Photo'"
                      (addedImagesChange)="uploadPhoto($event, 'after_job')"
                      [showTextLink]="true"
                      style="margin-right: 10px" />
                    <tidy-file-upload
                      [accept]="'video/mp4'"
                      [showPreview]="false"
                      [label]="isNativeMobile ? 'Upload Video' : 'Add Video'"
                      (addedImagesChange)="uploadVideo($event, 'after_job')"
                      [showTextLink]="true" />
                  </div>
                }
              </div>
              @if (!isFullWidth) {
                <div style="margin-top: 10px; display: flex; align-items: center; align-items: center;">
                  @if (isNativeMobile) {
                    <tidy-text
                      [actionBody]="'Take Photo'"
                      (action)="takePhoto('after_job')"
                      class="link"
                      style="margin-right: 10px" />
                  }
                  <tidy-file-upload
                    [accept]="'image/*'"
                    [showPreview]="false"
                    [label]="isNativeMobile ? 'Upload Photo' : 'Add Photo'"
                    (addedImagesChange)="uploadPhoto($event, 'after_job')"
                    [showTextLink]="true"
                    style="margin-right: 10px" />
                  @if (isNativeMobile) {
                    <tidy-text
                      [actionBody]="'Take Video'"
                      (action)="takeVideo('after_job')"
                      class="link"
                      style="margin-right: 10px" />
                  }
                  <tidy-file-upload
                    [accept]="'video/mp4'"
                    [showPreview]="false"
                    [label]="isNativeMobile ? 'Upload Video' : 'Add Video'"
                    (addedImagesChange)="uploadVideo($event, 'after_job')"
                    [showTextLink]="true" />
                </div>
              }
              @if (afterPhotos?.length == 0) {
                <tidy-row class="extra-top-padding">
                  <tidy-text [helper]="'None Added'" />
                </tidy-row>
              }
              <ion-row>
                @for (item of afterPhotos; track item; let i = $index) {
                  <ion-col [size]="isFullWidth ? 6 : 12">
                    @if (item.mediaType === 'video') {
                      <tidy-row>
                        <tidy-video
                          class="before-after-video"
                          [src]="item?.url"
                          style="width: 100%; height: auto; max-width: 100%;" />
                      </tidy-row>
                    }
                    @if (item.mediaType === 'photo') {
                      @if (item?.url) {
                        <tidy-photo-note
                          class="full-width no-margin photo-note-job"
                          [src]="item?.url"
                          style="width: 100%; height: auto; max-width: 100%;" />
                      }
                    }
                    @if (item?.metadata || item?.uploadedBy) {
                      <div class="timestamp-caption">
                        <tidy-row [alignLastItemRight]="true">
                          <tidy-text
                            [smallBody]="('Uploaded by: ' | translate) + (item?.uploadedBy ? (item?.uploadedBy | translate) : ('You' | translate))"
                            class="white" />
                          <div>
                            <tidy-image
                              [src]="'assets/img/trash-outline-white.svg'"
                              (action)="removePhoto(item, i, 'after_job')"
                              class="body-size"
                              style="cursor: pointer" />
                          </div>
                        </tidy-row>
                        @if (item?.metadata?.location) {
                          <tidy-row>
                            <tidy-text
                              [smallBody]="'Location:'"
                              class="white" /><span>&nbsp;</span>
                            <tidy-text
                              [smallBody]="item?.metadata?.location"
                              class="white" />
                          </tidy-row>
                        }
                        @if (item?.metadata?.displayDate) {
                          <tidy-row>
                            <tidy-text
                              [smallBody]="'Timestamp:'"
                              class="white" />
                            <tidy-text
                              [smallBody]="(item?.metadata?.displayDate | parseDateTime: 'ddd MMM d') + ' ' + (item?.metadata?.displayDate | parseDateTime: 'h:mma')"
                              class="white" />
                          </tidy-row>
                        }
                      </div>
                    }
                  </ion-col>
                }
              </ion-row>
            </tidy-card>
          }
        </ion-col>

        @if (!isRightSideContent && windowService.isDesktopRes) {
          <ion-col [sizeLg]="4" [sizeSm]="6">
            @if (job?.job?.status !== 'completed' && job?.job?.status !== 'incomplete') {
              <tidy-row style="padding-top: 18px" />
            }
            <tidy-card style="padding: 0px">
              <div [attr.id]="'map' + jobId" #map style="width: 100%; height: 300px; border-radius: 6px;"></div>
            </tidy-card>
            @for (item of activity; track item) {
              <tidy-card>
                <tidy-row class="extra-bottom-padding" [alignLastItemRight]="true">
                  <div>
                    <tidy-initials-icon
                      [fullName]="item?.pro?.first_name + ' ' + (item?.pro?.last_name ? item?.pro?.last_name : '')"
                      style="margin-right: 5px;" />
                    <tidy-text
                      [header]="item?.pro?.text ? item?.pro?.text : (item?.pro?.first_name + ' ' + (item?.pro?.last_name ? item?.pro?.last_name : ''))"
                      [translate]="false" />
                  </div>
                  <div style="position: relative; margin-left: 5px">
                    @if (item?.pro?.first_name) {
                      <tidy-image
                        [src]="'assets/img/messages.svg'"
                        class="title-size white-icon"
                        (action)="goToMessageThreadPage(item?.pro)" />
                    }
                    @if (item?.numberOfUnreadMessages > 0) {
                      <div style="position: absolute; top: -8px; right: -8px; background: #CB393C; color: white; border-radius: 50%; min-width: 18px; height: 18px; display: flex; align-items: center; justify-content: center; font-size: 12px; padding: 0 4px; font-family: Inter, Arial, sans-serif;">
                        {{item?.numberOfUnreadMessages}}
                      </div>
                    }
                  </div>
                </tidy-row>
                @for (update of item?.updates; track update) {
                  <tidy-row>
                    <message [message]="update" />
                  </tidy-row>
                }
              </tidy-card>
            }
          </ion-col>
        }
      </ion-row>
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [isfullWidthContent]="windowService.isDesktopRes" [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}

